
/**
 * Accepts a list of query strings and returns a StringMap with found arguments.
 */
export function getQueryStringMap(keys: string[]): StringMap {
    const map = new StringMap();
    keys.forEach(key => {
        const args = getParameterByName(key);
        if (args !== null) {
            map.set(key, args);
        }
    });
    return map;
}

/**
 * Borrowed from here: https://stackoverflow.com/questions/45790423/how-to-get-parameter-name
 */
function getParameterByName(name: string, url?: string) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
 * Class to encapsulate the concept of a String>String 1-to-1 Map.
 */
export class StringMap {
    private map = {};
    public has(key: string): boolean {
        return key in this.map;
    }
    public get(key: string): string | undefined {
        return this.map[key];
    }
    public set(key: string, value: string) {
        this.map[key.toString()] = value;
    }
    public delete(key: string): string {
        const newMap = {};
        Object.keys(this.map).forEach(k => {
            if (k !== key.toString()) {
                newMap[k] = this.map[k];
            }
        });
        const deleted = this.map[key];
        this.map = newMap;
        return deleted;
    }
}